/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_cloud_logic_custom": [
        {
            "name": "apifetchdata",
            "endpoint": "https://ht6jio0xrb.execute-api.us-west-2.amazonaws.com/prod",
            "region": "us-west-2"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://ah2gzx5zdrel3csp6obhtctgtu.appsync-api.us-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-ckhh7aekz5ahrhhfglutfooi7u",
    "aws_cognito_identity_pool_id": "us-west-2:47c5af52-e963-4349-80fe-4c7752709099",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_LLZTeB8Je",
    "aws_user_pools_web_client_id": "47bh74pb0q4mjnfks7s05fijtb",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "lf-api-storage-2b19a34bccf91-prod",
    "aws_user_files_s3_bucket_region": "us-west-2"
};


export default awsmobile;
